{
	"category": {
		"doctoral_and_specialization": "Doctorate and specialization",
		"first_year": "First year",
		"later_years": "Later years"
	},
	"channel": {
		"email": "Email",
		"residence_pec": "PEC of the residence"
	},
	"columns": {
		"actions": "Actions",
		"channel": "Channel",
		"deadline": "Deadline",
		"name": "Student",
		"protocol": "Protocol",
		"quota": "Quota",
		"reply": "Last answer",
		"sent": "Sending",
		"state": "State"
	},
	"contact": {
		"command": "Note a contact",
		"description": "Write how and when you told the student, for example by phone. The note does not change the term of the offer.",
		"error": "The note could not be saved.",
		"label": "Note",
		"save": "Save the note",
		"success": "Note saved.",
		"title": "Note a contact with the student"
	},
	"decision": {
		"accept": "Acceptance",
		"decline": "Refusal"
	},
	"errors": {
		"default": "The offers could not be loaded.",
		"offer_not_bounced": "The offer is no longer marked as not delivered.",
		"offer_not_to_send_by_pec": "The offer is not to be sent from the PEC of the residence."
	},
	"expiries": {
		"confirm": {
			"command": "Confirm the lapse",
			"confirm": "Confirm the lapse",
			"description": "The student loses the seat in this residence and gets the email of the lapse. The seat goes to the next in the ranking with the next calculation.",
			"error": "The lapse could not be confirmed.",
			"success": "Lapse confirmed.",
			"title": "Confirm the lapse?"
		},
		"delivered": "Delivered",
		"due": "To confirm by {{date}}",
		"empty": "No lapses to confirm.",
		"expired": "Expired at midnight at the end of {{day}}",
		"late": "Late",
		"late_reply": "Late",
		"late_reply_text": "{{decision}} received on {{date}}",
		"not_delivered": "Not delivered",
		"reminder": "Before confirming, check whether the student answered to the PEC of the call or by other means.",
		"reply": {
			"accept": "Accepts the seat",
			"after_deadline": "The answer arrived after the deadline: it does not cancel the lapse.",
			"closed": "The offer is no longer to confirm: it is now «{{state}}».",
			"command": "Record the answer received",
			"date": "Day of receipt",
			"decision": "Answer",
			"decline": "Declines the seat",
			"description": "Upload the message received as proof (.eml, PDF or image, 25 MB at most). From an .eml the system proposes the time it was received: check it before recording.",
			"error": "The answer could not be recorded.",
			"file": "Proof of the answer",
			"not_read": "The file does not say when it arrived: write the time of the receipt.",
			"proposed": "Time of receipt read from the message: check it.",
			"reading": "Reading the message…",
			"record": "Record the answer",
			"success_accept": "Acceptance recorded: the lapse is cancelled.",
			"success_decline": "Refusal recorded.",
			"time": "Time of receipt",
			"title": "Record the answer of the student",
			"too_large": "The file is larger than 25 MB.",
			"upload_failed": "The file was not uploaded.",
			"uploading": "Uploading…"
		},
		"sent": "Sent on {{date}}",
		"title": "Lapses to confirm"
	},
	"launch": {
		"assigned_note": "The recipients are those assigned a seat by the final ranking, version {{version}}. The manager cannot add or remove recipients.",
		"assigned_title_one": "{{count}} student will receive the offer",
		"assigned_title_other": "{{count}} students will receive the offer",
		"blocked": {
			"already_launched": "The offers of this call have already started.",
			"contract_info_link": "Fill them in on the residence page",
			"contract_info_missing": "The contract and payment data are missing (IBAN, account holder, signing, deposit): the offers carry them and do not start without them.",
			"ministry_answer_missing_one": "{{seats}} DSU seats are uncovered and {{count}} student of the 70% quota list has no DSU seat: the offers start once you record the answer of the Ministry. With a yes, those seats go to the first of the 70% list at the DSU rate; with a no they stay uncovered. If no answer comes, the general admin can release the offers.",
			"ministry_answer_missing_other": "{{seats}} DSU seats are uncovered and {{count}} students of the 70% quota list have no DSU seat: the offers start once you record the answer of the Ministry. With a yes, those seats go to the first of the 70% list at the DSU rate; with a no they stay uncovered. If no answer comes, the general admin can release the offers.",
			"ranking_not_final": "The ranking is not final yet: the offers can start when the window for the reports of the students ends.",
			"ranking_not_final_until": "The ranking is not final yet: the offers can start after {{date}}, when the window for the reports of the students ends.",
			"recalculation_pending": "The ranking is being calculated again, for example after the yes of the Ministry: the offers start from the new version. Reload the page in a minute."
		},
		"changed": "The ranking changed (version {{number}}): check the recipients again.",
		"command": "Start the offers",
		"confirm": "Start",
		"confirm_description_one": "{{count}} offer leaves. {{when}} After the start, every new calculation of the ranking makes the offers of the seats that come free by itself.",
		"confirm_description_other": "{{count}} offers leave. {{when}} After the start, every new calculation of the ranking makes the offers of the seats that come free by itself.",
		"confirm_title": "Start the offers?",
		"error": "The offers could not be started. Try again.",
		"later": "The offers will leave on {{day}} at {{time}}.",
		"none": "No one is assigned a seat in the final ranking: there is no offer to start.",
		"now": "The emails leave now.",
		"success_one": "Offers started: {{count}} offer",
		"success_other": "Offers started: {{count}} offers",
		"text_note": "The text is the one of the rules of the call, with the data of the residence and an example student.",
		"text_title": "Text of the offer",
		"title": "Start of the offers"
	},
	"list": {
		"empty": "No offers.",
		"empty_filtered": "No offers in this state.",
		"expiries_link": "Lapses to confirm",
		"filter": "State",
		"launched": "Offers started on {{date}}",
		"overbooked": "Seats held beyond the quota after a correction: {{q30}} in the 30% quota, {{q70}} in the 70% quota. No offer is taken back.",
		"unfilled": "Seats not covered: {{q30}} in the 30% quota, {{q70}} in the 70% quota."
	},
	"origin": {
		"initial": "Initial",
		"scrolling": "Scrolling"
	},
	"page_title": "Offers",
	"pec": {
		"body": "Text",
		"command": "Send from the PEC",
		"copied": "Copied.",
		"copy": "Copy",
		"date": "Day of the receipt",
		"description": "Copy the text and send it from the PEC of the residence to the address of the student. Then record the time of the acceptance receipt: the term of the offer starts from there.",
		"error": "The sending could not be recorded.",
		"future": "The time cannot be in the future.",
		"recipient": "Recipient",
		"record": "Record the sending",
		"subject": "Subject",
		"success": "Sending recorded: the term of the offer started.",
		"time": "Time of the receipt",
		"title": "Send the offer from the PEC of the residence"
	},
	"quota": {
		"q30": "30% quota",
		"q70": "70% quota"
	},
	"reply_state": {
		"ignored": "Ignored",
		"late": "Late"
	},
	"resend": {
		"command": "Send again",
		"confirm": "Send again",
		"description": "The offer leaves again to the same address at the next opening of the sending hours, and its term starts again from the new sending. If this email does not arrive either, the term runs anyway: you can call the student and note it.",
		"error": "The offer could not be sent again.",
		"success": "The offer will leave at the next opening of the sending hours.",
		"title": "Send the offer again?"
	},
	"row": {
		"by_pec": "To send from the PEC of the residence",
		"contact_note": "Contact: {{note}}",
		"deadline": "by midnight at the end of {{day}}",
		"not_delivered": "The email did not arrive",
		"reply": "{{decision}} on {{date}}",
		"reply_none": "None",
		"send_after": "Leaves on {{date}}"
	},
	"state": {
		"accepted": "Accepted",
		"bounced": "Not delivered",
		"declined": "Declined",
		"expired": "Lapsed",
		"expiry_proposed": "To confirm",
		"renounced_after_acceptance": "Renounced after acceptance",
		"revoked": "Revoked",
		"scheduled": "To send",
		"sent": "Sent",
		"withdrawn": "Withdrawn"
	}
}
